<template>
<svg id="Layer_1" data-name="Layer 1" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 90.07 90.07">
  <path class="cls-2" d="m29.05,73.87c-.19,0-.35-.16-.35-.35V17.07c0-.19.16-.35.35-.35s.35.16.35.35v56.45c0,.19-.16.35-.35.35Z"/>
  <path class="cls-2" d="m43.75,73.87c-.19,0-.35-.16-.35-.35V17.07c0-.19.16-.35.35-.35s.35.16.35.35v56.45c0,.19-.16.35-.35.35Z"/>
  <path class="cls-2" d="m58.46,73.87c-.19,0-.35-.16-.35-.35V17.07c0-.19.16-.35.35-.35s.35.16.35.35v56.45c0,.19-.16.35-.35.35Z"/>
  <path class="cls-2" d="m73.17,73.87c-.19,0-.35-.16-.35-.35V17.07c0-.19.16-.35.35-.35s.35.16.35.35v56.45c0,.19-.16.35-.35.35Z"/>
  <path class="cls-1" d="m16.21,65.04c-.29,0-.59-.09-.84-.28-.62-.47-.74-1.35-.27-1.96l13.48-17.81,14.51,5.7,14.89-29.27,16.04,12.19c.62.47.74,1.35.27,1.96-.47.62-1.35.74-1.96.27l-13.37-10.16-14.53,28.54-14.9-5.86-12.2,16.11c-.28.36-.69.56-1.12.56Z"/>
  <path class="cls-3" d="m73.17,75.27H14.46V16.55c0-.97.78-1.75,1.75-1.75s1.75.78,1.75,1.75v55.21h55.21c.97,0,1.75.78,1.75,1.75s-.78,1.75-1.75,1.75Z"/>
  <circle class="cls-3" cx="29.05" cy="47.48" r="2.44"/>
  <circle class="cls-3" cx="43.75" cy="52.41" r="2.44"/>
  <circle class="cls-3" cx="58.46" cy="23.72" r="2.44"/>
  <circle class="cls-3" cx="73.17" cy="34.46" r="2.44"/>
</svg>
</template>

<script>
export default {
    name: "YoyTrendTableIcon",
}
</script>

<style scoped>
  .cls-1 {
    fill: #59c5c7;
  }
  .cls-2 {
    fill: #b6dfcf;
  }
  .cls-3 {
    fill: #135d73;
  }
</style>